import Component from './component';
import fixtures from './fixtures';
import transform from './transformer';

const SimilarProperties = (props) => <Component {...transform(props)} />;

export default SimilarProperties;

export { Component as component, fixtures, transform as transformer };
